import { createFileRoute } from '@tanstack/react-router'

import { SpacesPage } from '@/pages/spaces/Spaces.page'

export const Route = createFileRoute('/_auth/$companyId/spaces/')({
  component: SpacesPage,
})
